import { Search } from '@styled-icons/bootstrap/Search';
import { CompetitionListSchema } from '@/views/sports/components/CompetitionList/styles/CompetitionList.styles';

export const competitionListStyles: CompetitionListSchema = {
  skeleton: {
    startColor: 'alpha.300',
    endColor: 'alpha.400',
    minW: 'full',
    h: '20',
    borderRadius: 'lg',
    flex: 1,
    mt: '8',
  },
  input: {
    name: 'x',
    sxWrapper: { mb: '0' },
    bg: 'blackAlpha.600',
    border: 'none',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.05)',
    borderRadius: 'md',
    color: 'white',
    mb: '0',
    _hover: {
      '&&': {
        bg: 'blackAlpha.600',
        _placeholder: {
          color: 'gray.400',
        },
      },
      borderColor: 'alpha.500',
      color: 'white',
    },

    _focus: {
      '&&': {
        bg: 'blackAlpha.600',
        _placeholder: {
          color: 'gray.400',
        },
      },
      boxShadow: 'xl',
      borderColor: 'alpha.500',
      color: 'white',
      textShadow: 'sm',
    },
    _placeholder: {
      color: 'whiteAlpha.500',
      fontWeight: 'bold',
      fontSize: '2xs',
    },
  },
  inputRightIcon: {
    boxSize: '5',
    color: 'beta.500',
    as: Search,
    sx: {},
  },
  accordion: {
    color: 'white',
    mb: '3',
    variant: 'unstyled',
    w: 'full',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    py: '2',
  },
  accordionButton: {
    px: '0',
    pos: 'relative',
    _hover: { bg: 'transparent' },
  },
  hStack: {
    w: 'full',
    alignItems: 'center',
  },
  flex: { alignItems: 'center', gap: 2, flex: 1, textAlign: 'left' },
  accordionButtonIconSvg: {
    color: 'beta.200',
    fontSize: 'md',
    sx: {},
  },
  accordionButtonText: {
    fontSize: ['sm', 'md'],
    fontFamily: 'heading',
    fontWeight: 'normal',
    textTransform: 'uppercase',
    color: 'white',
  },
  marketTypesFlex: {
    mr: '2',
    gap: '2',
  },
  marketTypesText: {
    w: ['50px', '100px'],
    fontSize: '2xs',
    fontWeight: 'medium',
  },
  accordionButtonInnerIcon: {
    pos: 'absolute',
    right: '0',
    boxSize: '6',
    color: 'white',
    sx: {},
  },
  accordionPanel: {
    p: '0',
    mb: '3',
  },
};
